// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31vrL","image":"Header_image__1Ybu4","name":"Header_name__29SyS","info":"Header_info__1ciFs","infoRow":"Header_infoRow__3-Vh_"};